export function formatAsTwoLinesBarcode(barcode) {
    return barcode
        .replace(/\D/g, '')
        .replace(/(\d{5})(\d)/, '$1.$2')
        .replace(/(\d{5})(\d)/, '$1 $2')
        .replace(/(\d{5})(\d)/, '$1.$2')
        .replace(/(\d{6})(\d)/, '$1\n$2')
        .replace(/(\d{5}).(\d{5}) (\d{5}).(\d{6})\n(\d)/, '$1.$2 $3.$4\n$5')
        .replace(/(\d{5}).(\d{5}) (\d{5}).(\d{6})\n(\d{5})(\d)/, '$1.$2 $3.$4\n$5.$6')
        .replace(/(\d{5}).(\d{5}) (\d{5}).(\d{6})\n(\d{5}).(\d{6})(\d)?/, '$1.$2 $3.$4\n$5.$6 $7')
        .replace(/(\d{5}).(\d{5}) (\d{5}).(\d{6})\n(\d{5}).(\d{6}) (\d)(\d)?/, '$1.$2 $3.$4\n$5.$6 $7 $8')
        .replace(/(\d{14,15})\d?$/, '$1');
}
